export const unityOptions = [
    { value: 'UI/dia', label: 'UI/dia' },
    { value: 'mcg/dia', label: 'mcg/dia' },
    { value: 'cap/dia', label: 'cap/dia' },
    { value: 'g/dia', label: 'g/dia' },
    { value: 'gt/dia', label: 'gt/dia' },
    { value: 'mg/dia', label: 'mg/dia' },
    { value: 'Mi UFC/dia', label: 'Mi UFC/dia' },
    { value: 'Bi UFC/dia', label: 'Bi UFC/dia' },
];